<template>
  <div class="user-manage">
    <div class="little-tip">用户管理</div>
    <div class="user-manage-right-top">
      <el-button type="primary" @click="handleAdd">新增</el-button>
      <el-popover placement="bottom" width="160" v-model="visible">
        <el-checkbox-group v-model="checkList">
          <el-checkbox v-for="(item, i) in tableHeaderList" @change="handleChangeCheckBox" :label="item.label" :key="i"></el-checkbox>
        </el-checkbox-group>
        <i slot="reference" class="user-manage-screen-btn" />
      </el-popover>
    </div>
    <div class="user-manage-right-table">
      <el-table stripe :data="tableData" border style="width: 100%" height="100%">
        <el-table-column type="selection" width="36"></el-table-column>
        <el-table-column v-if="tableHeaderList[0].status" prop="id" label="序号" width="72"/>
        <el-table-column v-if="tableHeaderList[1].status" show-overflow-tooltip prop="user_name" label="用户账号"/>
        <el-table-column v-if="tableHeaderList[2].status" show-overflow-tooltip prop="nick_name" label="昵称"/>
        <el-table-column v-if="tableHeaderList[3].status" prop="firm_name" label="所属组织" sortable/>
        <el-table-column v-if="tableHeaderList[4].status" prop="create_time" label="创建时间"/>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="user-manage-table-icon" @click="handleUpt(scope.row)">修改</span>
            <span class="user-manage-table-icon" @click="handleFreeze(scope.row)">{{ scope.row.status === 1 ? '冻结' : '解除冻结' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[50, 100, 200, 500]"
      :page-size="limit"
      layout="prev, pager, next, jumper, total, sizes"
      :total="count">
    </el-pagination>
    <el-dialog
      :visible.sync="dialogVisible"
      width="35%"
      :show-close="false"
      :before-close="handleClose">
      <template slot="title">
        <el-divider content-position="left">{{ dialogTitle }}</el-divider>
      </template>
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-form-item v-if="dialogTitle === '用户'" label="用户号" prop="id">
          <el-input v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item v-if="dialogTitle === '新增用户'" label="用户账号" prop="user_name">
          <el-input v-model="form.user_name"></el-input>
        </el-form-item>
        <el-form-item v-if="dialogTitle === '新增用户'" label="所属组织" prop="firm_id">
          <div class="diy-suffix">
            <el-select id="form_firm_id" v-model="form.firm_id" placeholder="请选择">
              <el-option v-for="item in firmList" :key="item.id" :label="item.firm_name" :value="item.id"></el-option>
            </el-select>
            <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('form_firm_id')" />
          </div>
        </el-form-item>
        <el-form-item label="昵称" prop="nick_name">
          <el-input v-model="form.nick_name"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetUserList, GetFirmList, PostUserAdd, PostUserEdit, PostUserFreeze } from '../../api/user'
export default {
  data () {
    var validateUserName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户账号'))
      }
      var reg = /^[a-zA-Z0-9_\-]{4,40}$/
      if (!reg.test(value)) {
        callback(new Error('账号由数字、英文、下划线和连接号组成'))
      } else {
        callback()
      }
    }
    var validateUserId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户号'))
      }
      var reg = /^[0-9]{0,11}$/
      if (!reg.test(value)) {
        callback(new Error('请输入最多11位的正整数'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      dialogVisible: false,
      dialogTitle: '新增用户',
      page: 1,
      limit: 100,
      count: 0,
      form: {},
      firmList: [],
      tableData: [],
      tableHeaderList: [
        { label: '序号', status: true },
        { label: '组织名', status: true },
        { label: '组织角色', status: true },
        { label: '是否展示', status: true },
        { label: '创建时间', status: true }
      ],
      rules: {
        id: [
          { required: true, validator: validateUserId, trigger: 'blur' }
        ],
        user_name: [
          { required: true, validator: validateUserName, trigger: 'blur' },
          { min: 4, max: 40, message: '用户账号长度为4-40个字符', trigger: 'blur' }
        ],
        firm_id: [
          { required: true, message: '请选择所属组织', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 32, message: '密码长度为4-40个字符', trigger: 'blur' }
        ],
        nick_name: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { max: 80, message: '超出最大长度80个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    checkList: {
      get () {
        return this.tableHeaderList.filter(v => v.status).map(v => v.label)
      },
      set (newVal) {
        for (let i = 0; i < this.tableHeaderList.length; i++) {
          this.tableHeaderList.status = newVal
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      const { page, limit } = this
      const params = {
        page,
        limit
      }
      await GetFirmList(params).then(res => {
        if (res && res.data.length) {
          this.firmList = res.data
        }
      })
      await GetUserList(params).then(res => {
        if (res) {
          const { count, data } = res
          this.tableData = data
          this.count = count
        }
      })
    },
    filterHandler (value, row, column) {
      const property = column.property
      return row[property] === value
    },
    handleAdd () {
      this.dialogTitle = '新增用户'
      this.dialogVisible = true
    },
    handleUpt (row) {
      this.form = { ...row }
      this.dialogTitle = '修改用户'
      this.dialogVisible = true
    },
    handleFreeze (row) {
      const { id, status } = row
      const params = {
        id,
        status: status === 1 ? 2 : 1
      }
      PostUserFreeze(params).then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.init()
        }
      })
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url = ''
          let params = {}
          if (this.dialogTitle === '新增用户') {
            url = PostUserAdd
            params = { ...this.form }
          } else {
            url = PostUserEdit
            params = {
              id: this.form.id,
              user_name: this.form.user_name,
              firm_id: this.form.firm_id,
              nick_name: this.form.nick_name,
              password: this.form.password
            }
          }
          url(params).then(res => {
            if (res) {
              this.$message.success(res.msg)
              this.dialogVisible = false
              this.init()
            }
          })
        }
      })
    },
    handleChangeCheckBox (value, e) {
      for (let i = 0; i < this.tableHeaderList.length; i++) {
        if (this.tableHeaderList[i].label === e.target.defaultValue) {
          this.tableHeaderList[i].status = value
        }
      }
    },
    handleFouceSelect (val) {
      document.getElementById(val).click()
    },
    handleClose () {
      this.form = {}
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    handleSizeChange (val) {
      this.limit = val
      this.init()
    },
    handleCurrentChange (val) {
      this.page = val
      this.init()
    }
  }
}
</script>

<style lang="less">
.user-manage {
  position: relative;
  height: calc(100% - 130px);
  margin: 30px 20px 40px 20px;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0px 1px 6px 1px rgba(34, 82, 177, 0.07);
  padding: 15px 12px;
  width: 1180px;
  margin: 30px auto;
  .el-dialog__header {
    padding: 0;
    padding-top: 10px;
    .el-divider__text {
      color: #02044A;
      font-size: 22px;
      padding: 0 15px;
    }
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0;
    padding-bottom: 40px;
    .el-button {
      padding: 12px 60px;
      font-size: 18px;
      letter-spacing: 4px;
    }
    .el-button+.el-button {
      margin-left: 40px;
    }
    .el-button--primary {
      background: #0C75FF;
    }
    .el-button--default {
      background: #DDDDDD;
      color: #676767;
    }
  }
  .el-table td, .el-table th {
    text-align: center;
  }
  .little-tip {
    position: absolute;
    color: #e0e0e0;
    font-size: 14px;
    top: -26px;
    left: 0;
  }
  .user-manage-right-top {
    height: 40px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    .user-manage-screen-btn {
      display: inline-block;
      width: 40px;
      height: 40px;
      background: url('../../assets/img/screen-noselect-btn.png') no-repeat;
      background-size: 100% 100%;
    }
    .el-button {
      height: 40px;
      padding: 10px 36px;
      font-size: 16px;
      background-color: #8FB98A;
      border-color: #8FB98A;
      letter-spacing: 4px;
    }
  }
  .user-manage-right-table {
    width: 100%;
    height: calc(100% - 94px);
    overflow: hidden;
    margin-bottom: 10px;
    border-right: 1px solid #CCCCD8;
    border-bottom: 1px solid #CCCCD8;
    .user-manage-table-icon {
      margin: 0 5px;
      cursor: pointer;
    }
    .el-table {
      height: 100%;
      border-color: #CCCCD8;
      th {
        color: #02044A;
        background: #E8EEF6;
        border-color: #CCCCD8;
        font-weight: normal;
      }
      td {
        color: #74758F;
        border-color: #CCCCD8;
      }
      .el-table-column--selection .cell {
        padding-right: 10px;
      }
    }
  }
  .gongneng-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    background-size: 100% 100%;
    transform: translateY(3px);
  }
  .car-icon {
    background-image: url('../../assets/img/car.png');
  }
  .message-icon {
    background-image: url('../../assets/img/message.png');
  }
  .delete-icon {
    background-image: url('../../assets/img/delete.png');
    margin-right: 0;
  }
  .el-pagination__total {
    margin-left: 10px;
  }
  .el-form {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      width: calc(50% - 5px);
      margin-right: 10px;
      border: 1px solid #DDDDE6;
      border-radius: 4px;
      .el-input__inner {
        border: 0;
      }
      .el-input {
        margin-left: 10px;
        width: calc(100% - 10px);
      }
      .el-select {
        width: 100%;
      }
      &:nth-child(2n) {
        margin-right: 0;
      }
      .el-form-item__label {
        border: 0;
        background: #F0F1F4;
        color: #6E6F95;
        font-size: 14px;
        text-align: center;
        padding-right: 0;
        height: 41px;
        border-right: 1px solid #DDDDE6;
      }
    }
    .diy-suffix {
      position: relative;
      .diy-suffix-icon {
        position: absolute;
        right: 7px;
        top: 2px;
        cursor: pointer;
      }
    }
    .el-input__suffix {
      display: none;
    }
  }
}
</style>
